<template>
   <vue-html2pdf v-if="report && printStaticData"
      :show-layout="false" :float-layout="true" :enable-download="false" :preview-modal="true"
      :filename="(report && report.user_full_name) ? report.user_full_name : 'workday report'" :pdf-quality="2"
      :manual-pagination="true" pdf-format="a4" pdf-orientation="portrait" ref="html2Pdf">
      <section slot="pdf-content" :dir="$vuetify.rtl ? 'rtl' : 'ltr'">
         <PrintPDF :header="[]" :maxPDFRows="20" :data="[{}]" :header_slot="false" :content_slot="true"
            :footer_slot="false" :showGroupHeader="false" :groupHeader="false" :footerData="[]"
            :customize_header_footer="true" :printStaticData="printStaticData">
            <template v-slot:pdf_content>
               <component
                  :is="printTemplateComponent"
                  :report="report"
                  :print-static-data="printStaticData"
               />
            </template>
         </PrintPDF>
      </section>
   </vue-html2pdf>
</template>

<script>
import PrintPDF from "@/components/PrintPDF.vue";
import VueHtml2pdf from "vue-html2pdf";
import ShiftsPrintTemp1 from "@/views/POS/Shifts/ShiftsPrintTemp1.vue";
import ShiftsPrintTemp2 from "@/views/POS/Shifts/ShiftsPrintTemp2.vue";

const PRINT_TEMPLATES = {
   temp_1: "ShiftsPrintTemp1",
   temp_2: "ShiftsPrintTemp2",
};

export default {
   name: "ShiftSummery",
   components: {
      PrintPDF,
      VueHtml2pdf,
      ShiftsPrintTemp1,
      ShiftsPrintTemp2,
   },
   computed: {
      printTemplateType() {
         return (this.printStaticData && this.printStaticData.temp) ? this.printStaticData.temp : "temp_1";
      },
      printTemplateComponent() {
         return PRINT_TEMPLATES[this.printTemplateType] || PRINT_TEMPLATES.temp_1;
      },
   },
   mounted() {
      if (this.$route.params.report && this.$route.params.printStaticData) {
         this.report = this.$route.params.report;
         this.printStaticData = this.$route.params.printStaticData;
         this.$nextTick(() => {
            if (this.$refs.html2Pdf) {
               this.$refs.html2Pdf.generatePdf();
            }
         });
      }
   },
   data() {
      return {
         report: null,
         printStaticData: null,
      };
   },
   methods: {
   },
};
</script>

<style lang="scss" scoped>
.summary_row {
   padding: 0.4rem 0.2rem;
   border-bottom: 2px solid #eee;
   font-size: 12px !important;
   display: flex !important;
   justify-content: space-between !important;
}

td {
   padding: 1.2rem 0.4rem;
   font-size: 12px !important;
}

td:nth-of-type(1),
td:nth-of-type(4) {
   color: var(--gray7) !important;
}

#print_title {
   width: fit-content;
   text-align: center;
   font-size: 12px !important;
   color: var(--blue1);
   background: var(--blue12);
   display: block;
   padding: 1.2rem;
   margin: 30px auto;
}

.mini_table_two {
   width: 100%;
   border-collapse: collapse !important;

   tr {
      border: 1px solid #f7f9fb !important;

      th {
         text-transform: capitalize;

      }

      td,
      th {
         border: 1px solid #eee !important;
         background: #fff !important;
         height: 34.5px !important;
         font-size: 12px !important;
         padding: 12px;

      }

      td {
         background-color: #f5f6fa;
      }

      &:nth-of-type(odd) {

         td,
         th {
            background: #f7f9fb !important;
         }
      }

      // &:last-of-type {
      //
      //    td,
      //    th {
      //       font-weight: bold;
      //    }
      // }
   }
}
</style>